import styled, { css } from "styled-components";

interface IProps {
  isDisabled: boolean;
}

export const SwitchLabel = styled("label")<IProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 21px;
  border-bottom: 2px solid #ededed;
  transition: all 0.4s;
  color: unset;
  background-color: transparent;
  cursor: pointer;

  ${({ isDisabled, theme: { colors } }) => isDisabled && css`
    color: ${colors["hoki"]};
    background-color: ${colors["hoki-25"]};
    cursor: not-allowed;
  `}
`;
